import { render, staticRenderFns } from "./InclusiveGateway.vue?vue&type=template&id=06cc5048&scoped=true&"
import script from "./InclusiveGateway.vue?vue&type=script&lang=js&"
export * from "./InclusiveGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc5048",
  null
  
)

export default component.exports